import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import DataTable from "@/admin/DataTable";
import AuditTab from "@/admin/Audit";
import { useFetch, PageHeader, Loading, ErrorBox, fmtDate, apiError } from "@/admin/ui";

const Roles = () => {
  const { user } = useAuth();
  const { data, setData, error } = useFetch("/admin/students");
  const [q, setQ] = useState("");
  const rows = useMemo(() => (data || []).filter((u) => `${u.name} ${u.email}`.toLowerCase().includes(q.trim().toLowerCase()))
    .sort((a, b) => (a.role === b.role ? 0 : a.role === "admin" ? -1 : 1)), [data, q]);
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  const change = async (u, role) => {
    try {
      await api.put(`/admin/users/${u.id}/role`, { role });
      setData(data.map((x) => (x.id === u.id ? { ...x, role } : x)));
      toast.success(`${u.name} ahora es ${role === "admin" ? "Admin" : "Alumno"}.`);
    } catch (e) { toast.error(apiError(e)); }
  };
  const columns = [
    { key: "name", label: "Nombre", render: (r) => <b>{r.name}</b> },
    { key: "email", label: "Email", render: (r) => <span className="adm-sub">{r.email}</span> },
    { key: "last_seen", label: "Último acceso", render: (r) => <span className="adm-sub">{fmtDate(r.last_seen, true)}</span> },
    { key: "role", label: "Rol", render: (r) => (
      <Select value={r.role} onValueChange={(v) => change(r, v)} disabled={r.id === user.id}>
        <SelectTrigger className="w-[120px] bg-white h-8" data-testid={`admin-role-select-${r.id}`}><SelectValue /></SelectTrigger>
        <SelectContent><SelectItem value="admin">Admin</SelectItem><SelectItem value="student">Alumno</SelectItem></SelectContent>
      </Select>) },
  ];
  return (
    <>
      <p className="adm-sub" style={{ margin: "0 0 .75rem" }}>Admin: acceso completo a este panel. Alumno: solo la app. No puedes cambiar tu propio rol.</p>
      <input className="adm-input" style={{ maxWidth: 320, marginBottom: "1rem" }} placeholder="Buscar usuario" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-roles-search" />
      <DataTable columns={columns} rows={rows} testid="admin-roles-table" />
    </>
  );
};

export default function AdminAccess() {
  return (
    <div data-testid="admin-access">
      <PageHeader title="Accesos" subtitle="Roles y auditoría de seguridad" />
      <Tabs defaultValue="roles" className="adm-tabs">
        <TabsList>
          <TabsTrigger value="roles" data-testid="admin-access-tab-roles">Roles</TabsTrigger>
          <TabsTrigger value="auditoria" data-testid="admin-access-tab-auditoria">Auditoría</TabsTrigger>
        </TabsList>
        <TabsContent value="roles" className="mt-4"><Roles /></TabsContent>
        <TabsContent value="auditoria" className="mt-4"><AuditTab /></TabsContent>
      </Tabs>
    </div>
  );
}
